export function getFullName(
  patient: { firstName: string; lastName: string; preferredName?: string | null } | null,
): string {
  if (!patient) return '';
  return patient.preferredName
    ? `${patient.firstName} "${patient.preferredName}" ${patient.lastName}`
    : `${patient.firstName} ${patient.lastName}`;
}
